import { queryKey as n, queryFn as t } from "./main5.js";
function o(u) {
  return {
    queryFn: (r, e = []) => t(u, r, e),
    queryKey: (r, e = []) => n(u, r, e)
  };
}
export {
  o as createApi
};
